export type ToggleMenuEventDetail = {
    action: "open" | "close";
    identifier: string | null;
};

export class ToggleMenuEvent extends CustomEvent<ToggleMenuEventDetail> {
    public static readonly KEY = "toggle-menu";

    public constructor(eventInitDict: CustomEventInit<ToggleMenuEventDetail>) {
        super(ToggleMenuEvent.KEY, eventInitDict);
    }
}
